/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import { scrollToAnchor } from "../../theme/commonStyle";

const divorcePlannerStyle = {
  scrollToAnchor,
  navigationPaper: {
    display: "block",
  },
  imageContainer: {
    padding: "1rem",
  },
  imageCircle: {
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    width: "70px",
    height: "70px",
    padding: "18px",
    borderRadius: "50% !important",
    "& > img": {
      maxHeight: "40px",
    },
    border: "1px solid #333",
  },
  contentName: {
    fontSize: "1.125rem",
    color: "text.primary",
    fontWeight: 400,
  },
  processContainer: {
    padding: "1.5rem 1.5rem 1.5rem 0",
  },
  contentContainer: {
    padding: "1.5rem",
  },
  headlineContainer: {
    marginBottom: "10px",
  },
  headlineProcess: {
    paddingLeft: "1.5rem",
  },
  checklist: {
    marginTop: "2rem",
    borderTop: "1px solid #ccc",
    paddingTop: "2rem",
  },
  checklistHeader: {
    textAlign: "center",
  },
  checklistContainer: {
    marginLeft: "-12px",
  },
  primary: {
    color: "primary.main",
  },
};

export default divorcePlannerStyle;
